//Update this
const LICENSE_API = "https://d19xvu9xayq73j.cloudfront.net/api/get-license-url"; 
//const SHOP_DOMAIN = 'my-shop.myshopify.com';
const SHOP_DOMAIN = window.Shopify?.shop || window.location.hostname;

const inFlightLicenseChecks = new Map();
const resolvedLicenseChecks = new Map();

export async function checkLicense(includeModelCounter = false) {
  const requestKey = includeModelCounter ? "withModelCounter" : "default";

  if (resolvedLicenseChecks.has(requestKey)) {
    const cachedResult = resolvedLicenseChecks.get(requestKey);
    window.ModelViewerLicense = cachedResult;
    return cachedResult;
  }

  if (inFlightLicenseChecks.has(requestKey)) {
    return inFlightLicenseChecks.get(requestKey);
  }

  const requestPromise = (async () => {
  try {
    const modelCounterParam = includeModelCounter ? "&modelCounter=true" : "";
    const licenseUrl = `${LICENSE_API}?domain=${SHOP_DOMAIN}${modelCounterParam}`;
    //const res = await fetch(signedUrl);
    console.log("Checking license...:", licenseUrl); 

    // Get signed URL from API
    const res = await fetch(licenseUrl); //Add extra argument to log secondary counter
    if (!res.ok) throw new Error("Failed to get signed URL");
    const { signedUrl } = await res.json();

    // Fetch actual license file
    const licenseRes = await fetch(signedUrl);
    if (!licenseRes.ok) throw new Error("Failed to fetch license file");
    const license = await licenseRes.json();

    console.log("License:", license);

    const isValid = license.status === "valid";

    resolvedLicenseChecks.set(requestKey, isValid);
    window.ModelViewerLicense = isValid;
    return isValid;
  } catch (err) {
    console.error("License check failed", err);
    resolvedLicenseChecks.set(requestKey, false);
    window.ModelViewerLicense = false;
    return false;
  } finally {
    inFlightLicenseChecks.delete(requestKey);
  }
  })();

  inFlightLicenseChecks.set(requestKey, requestPromise);
  return requestPromise;
}
